import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
import { View } from '../ui/view';
import { extractChildren } from '../util/children';
import { Route } from './route';
import { Location } from './router';
var Switch = /** @class */ (function (_super) {
    tslib_1.__extends(Switch, _super);
    function Switch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switch.prototype.render = function () {
        var children = this.attrs.children;
        return m(Location, function (location) {
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                if (child.tag !== Route)
                    throw "Unexpected child type \"" + child.tag + "\", expected \"Route\"";
                var render = extractChildren(child.children);
                var match = location.match(child.attrs);
                if (!match)
                    continue;
                return render && m(render, { match: match, location: location });
            }
        });
    };
    return Switch;
}(View));
export { Switch };
